
        // Error handling for loading issues
        window.addEventListener('error', (e) => {
            console.error('Error loading script:', e);
            document.body.innerHTML += '<div style="color: red; padding: 20px; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); background: white; z-index: 1000;">Error: ' + e.message + '<br>Check console for details</div>';
        });
    